(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["best-sellers"]) return;
  try {
    
  (function() {
    let fade = false;
    if ($(window).width() < 1024) {
      fade = true;
    }

    $('.best-sellers .slider_wrap').slick({
      infinite: true,
      fade: fade,
      speed: fade ? 800 : 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '.best-sellers .arrow.left',
      nextArrow: '.best-sellers .arrow.right',
      cssEase: 'linear'
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    
  (function() {
    let fade = false;
    if ($(window).width() < 1024) {
      fade = true;
    }

    $('.product-slider .slider_wrap').slick({
      infinite: true,
      fade: fade,
      speed: fade ? 800 : 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '.product-slider .arrow.left',
      nextArrow: '.product-slider .arrow.right',
      cssEase: 'linear'
    });
  })();

  } catch(e) { console.error(e); }
})();

})();
